import $ from 'jquery';

$(() => {
  $('body').on('click', '.main-nav .standards > a', function (e) {
    $(this).next('ul').toggleClass('menu-open');
    $(this).parent().toggleClass('current');
    e.preventDefault();
  });
  $('.js-sign-in').on('click', (e) => {
    $('.account-options').addClass('open');
    e.preventDefault();
  });
  $('body').click((event) => {
    if ($(event.target).closest('.main-nav > ul li').length === 0) {
      $('.main-nav > ul li ul').removeClass('menu-open');
      $('.standards').removeClass('current');
    }
    if ($(event.target).closest('.account-menu').length === 0) {
      $('.account-options').removeClass('open');
    }
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/menu-dropdown.js
 **/